/*eslint-disable*/
import React, { useState } from 'react';
import { AccordionSection } from 'mapcontrols/components/subComponents';
import { AGENCIES_LIST, REPORTS } from 'mapcontrols/constants';
import { BaseSelect } from 'ui-kit';
import * as Styled from './styles';
import ReportAccordionSectionItem from './ReportAccordionSectionItem';

const ReportsSection = ({
  collapsedArrowIcon = '',
  expandedArrowIcon = '',
  activeSections = {},
  onSectionToggle = () => {},
}) => {
  const [selectedAgency, setSelectedAgency] = useState(AGENCIES_LIST[0]);

  const handleSelect = (value) => {
    setSelectedAgency(value);
  };

  return (
    <AccordionSection
      title="Reports"
      id="reports"
      activeSections={activeSections}
      onSectionToggle={onSectionToggle}
      collapsedArrowIcon={collapsedArrowIcon}
      expandedArrowIcon={expandedArrowIcon}
    >
      <Styled.SectionWrapper>
        <Styled.AgencySelectionWrapper>
          <BaseSelect
            name="agency"
            labelText="Agency"
            options={AGENCIES_LIST}
            value={selectedAgency}
            onChange={(selectedValue) => handleSelect(selectedValue)}
            inputId="agency-report"
          />
        </Styled.AgencySelectionWrapper>
        {REPORTS[selectedAgency.id].map(({ id, title, text }) => (
          <ReportAccordionSectionItem
            key={id}
            title={title}
            id={id}
            activeSections={activeSections}
            onSectionToggle={onSectionToggle}
            collapsedArrowIcon={collapsedArrowIcon}
            expandedArrowIcon={expandedArrowIcon}
            text={text}
          />
        ))}
      </Styled.SectionWrapper>
    </AccordionSection>
  );
};

export default ReportsSection;
